import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'src/app/containers/Registration/CheckMailboxContainer.scss';
import Layout from 'src/app/components/Layout/Layout';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';
import background from 'src/assets/images/background-registration.jpg';
import { sendActivationEmail } from 'src/app/redux/actions/registration/registration';


class CheckMailboxContainer extends React.Component {
  resendEmail = () => {
    const { dispatch, userId } = this.props;

    dispatch(sendActivationEmail(userId));
  };

  render() {
    const { email, sending } = this.props;
    const { resendEmail } = this;

    const classList = classNames({
      'resend': true,
      'resend--sending': sending
    });

    return (
      <Layout>
        <LayoutLeftColumn>
          <h4 styleName="title">Sprawdź pocztę i&nbsp;aktywuj konto</h4>

          <p styleName="information" data-test="text-success-message">
            Wysłaliśmy Ci wiadomość na adres
            <span styleName="information__email">{ email }</span>
            z linkiem aktywacyjnym.
          </p>

          <p styleName="additional-hint">Sprawdź pocztę i potwierdź ten adres e-mail.</p>

          <div styleName={ classList }>
            <h4 styleName="resend__title">Wiadomość nie dotarła?</h4>

            <button styleName="resend__send-email"
                    onClick={ resendEmail }
                    type="button"
            >
              Prześlij ponownie link aktywacyjny
            </button>
          </div>

        </LayoutLeftColumn>

        <LayoutRightColumn background={ background }>
          <h2 styleName="welcome__headline">
            Jesteś o krok od lepszej pracy.
          </h2>
          <h3 styleName="welcome__headline">
            Aktywuj swoje konto :)
          </h3>
        </LayoutRightColumn>
      </Layout>
    );
  }
}

CheckMailboxContainer.propTypes = {
  email: PropTypes.string.isRequired,
  sending: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired
};

const mapStateToProps = (store) => ({
  email: store.accountFormEmailReducer.value,
  sending: store.registrationReducer.sendingActivationEmail,
  userId: store.registrationReducer.userId
});

export default connect(mapStateToProps)(CheckMailboxContainer);
